/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { ModalBase } from '../modal/ModalBase';
import { Fade } from '../transition/Fade';
import { useBreakpoint } from '../hooks/useBreakpoint';
import { IconButton } from '../button/IconButton';
import { Typography } from '../typography/Typography';
import { Close } from '../private/icons/Close';

const placementMap = {
  top: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    }
  },
  'top-start': {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    }
  },
  'top-end': {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    }
  },
  bottom: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  },
  'bottom-start': {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  },
  'bottom-end': {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  },
  left: {
    anchorOrigin: {
      vertical: 'center',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'center',
      horizontal: 'right'
    }
  },
  'left-start': {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  },
  'left-end': {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    }
  },
  right: {
    anchorOrigin: {
      vertical: 'center',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'center',
      horizontal: 'left'
    }
  },
  'right-start': {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  },
  'right-end': {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    }
  }
};

function getOffsetTop(rect, vertical) {
  let offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}

function getOffsetLeft(rect, horizontal) {
  let offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical]
    .map((n) => (typeof n === 'number' ? `${n}px` : n))
    .join(' ');
}

function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

function debounce(func, wait = 166) {
  let timeout;
  function debounced(...args) {
    const later = () => {
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = () => {
    clearTimeout(timeout);
  };

  return debounced;
}

function ownerDocument(node) {
  if (node) {
    return node.ownerDocument;
  }
  return document;
}

function ownerWindow(node) {
  const doc = ownerDocument(node);
  return doc.defaultView || window;
}

const PopoverRoot = React.forwardRef(function Paper(props, ref) {

  const {
    style,
    smallScreen = false,
    ...other
  } = props;

  const classes = {
    root: 'sui-bg-primary sui-text-primary sui-rounded-base sui-shadow-sm sui-absolute sui-overflow-y-auto sui-overflow-x-hidden sui-outline-0'
  };

  const inlineStyles = {
    ...style
  };

  if (smallScreen) {
    inlineStyles.width = '100%';
  } else {
    inlineStyles.minWidth = '228px';
    inlineStyles.maxWidth = '400px';
  }

  return (
    <div
      className={classes.root}
      ref={ref}
      style={inlineStyles}
      {...other}
    />
  );
});

const Popover = React.forwardRef((props, ref) => {

  const {
    anchorEl,
    children,
    open,
    placement = 'bottom',
    title,
    ...other
  } = props;

  const paperRef = React.useRef();

  const matches = useBreakpoint('sm');

  const getAnchorOffset = React.useCallback(() => {
    const { anchorOrigin = { vertical: 'bottom', horizontal: 'center' } } = placementMap[placement] || {};

    const resolvedAnchorEl = resolveAnchorEl(anchorEl);

    const anchorElement = (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) ? resolvedAnchorEl : ownerDocument(paperRef.current).body;
    const anchorRect = anchorElement.getBoundingClientRect();

    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal),
    };
  }, [anchorEl, placement]);

  const getTransformOrigin = React.useCallback((elemRect) => {
    const { transformOrigin = { vertical: 'top', horizontal: 'center' } } = placementMap[placement] || {};

    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical),
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [placement]);

  const getPositioningStyle = React.useCallback(
    (element) => {
      const elemRect = {
        width: element.offsetWidth,
        height: element.offsetHeight,
      };

      if (matches.lesser) {
        return {
          left: '0px',
          right: '0px',
          bottom: '0px'
        };
      }

      const elemTransformOrigin = getTransformOrigin(elemRect);

      const anchorOffset = getAnchorOffset();

      let top = anchorOffset.top - elemTransformOrigin.vertical;
      let left = anchorOffset.left - elemTransformOrigin.horizontal;
      const bottom = top + elemRect.height;
      const right = left + elemRect.width;

      const containerWindow = ownerWindow(resolveAnchorEl(anchorEl));

      const marginThreshold = 16;

      const heightThreshold = containerWindow.innerHeight - marginThreshold;
      const widthThreshold = containerWindow.innerWidth - marginThreshold;

      if (top < marginThreshold) {
        const diff = top - marginThreshold;
        top -= diff;
        elemTransformOrigin.vertical += diff;
      } else if (bottom > heightThreshold) {
        const diff = bottom - heightThreshold;
        top -= diff;
        elemTransformOrigin.vertical += diff;
      }

      if (left < marginThreshold) {
        const diff = left - marginThreshold;
        left -= diff;
        elemTransformOrigin.horizontal += diff;
      } else if (right > widthThreshold) {
        const diff = right - widthThreshold;
        left -= diff;
        elemTransformOrigin.horizontal += diff;
      }

      return {
        top: `${Math.round(top)}px`,
        left: `${Math.round(left)}px`,
        transformOrigin: getTransformOriginValue(elemTransformOrigin),
      };
    }, [anchorEl, getAnchorOffset, getTransformOrigin]);

  const setPositioningStyles = React.useCallback(() => {
    const element = paperRef.current;

    if (!element) {
      return;
    }

    const positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }
    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }
    if (positioning.right !== null) {
      element.style.right = positioning.right;
    }
    if (positioning.bottom !== null) {
      element.style.bottom = positioning.bottom;
    }
    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);

  const handleEntering = () => {
    setPositioningStyles();
  };

  React.useEffect(() => {
    if (open) {
      setPositioningStyles();
    }
  });

  React.useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleResize = debounce(() => {
      setPositioningStyles();
    });

    const containerWindow = ownerWindow(anchorEl);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [anchorEl, open, setPositioningStyles]);

  const container = anchorEl ? ownerDocument(anchorEl).body : undefined;

  return (
    <ModalBase
      container={container}
      open={open}
      ref={ref}
      componentsProps={{
        backdrop: {
          invisible: true
        }
      }}
      {...other}
    >
      <Fade in={open} onEnter={handleEntering}>
        <PopoverRoot
          smallScreen={matches.lesser}
          ref={paperRef}
        >
          <div className="sui-flex sui-w-full sui-text-left sui-flex-col sui-gap-2 sui-p-3">
            <div className="sui-flex-auto sui-text-left">
              <div className="sui-flex sui-items-start sui-relative sui-items-center sui-gap-4">
                <span className="sui-grow">
                  <Typography variant="body-base" weight="bold">{title}</Typography>
                </span>
                <span>
                  <IconButton
                    aria-label="close"
                    onClick={props.onClose}
                    icon={Close}
                  />
                </span>
              </div>
            </div>
            {children}
          </div>
        </PopoverRoot>
      </Fade>
    </ModalBase>
  );
});

Popover.displayName = 'Popover';

Popover.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  /**
   * The prefered placement of the Tooltip component relative to the trigger object.
   * Note that the final placement could be different depending on available space and trigger location.
   */
  placement: PropTypes.oneOf([
    'bottom',
    'bottom-start',
    'bottom-end',
    'top',
    'top-start',
    'top-end',
    'left',
    'left-start',
    'left-end',
    'right',
    'right-start',
    'right-end'
  ]),
};

Popover.defaultProps = {
};

export { Popover };